<div kendoTooltip tooltipClass='me-tooltip' [ngClass]='{"icon-text-widget":true, "icon-text-widget-no-text":hidingText()}'>

	<div class="icon-text-widget fa-stack" [class.icon-sep-line]="!hidingText()"
		[attr.title]='hidingText() ? iconContext().text || null : null'>
		<i class="fa-fw {{iconContext().iconClass}} {{iconContext().iconStyle}} fa-stack-1x"
			[class.icon-faded]="!hidingText()"></i>
		<!-- <i *ngIf='iconSlashed' class="fa-fw fas fa-slash fa-stack-1x color-icon-slash"></i> -->
	</div>

	@if(!hidingText()){
	<div class="icon-text-widget-text" [class.icon-text-widget-has-subtext]="!!iconContext().subText">
		{{iconContext().text}}
		@if(iconContext().subText){
		<div class="icon-text-widget-subtext">{{ iconContext().subText }}
		</div>
		}
	</div>
	}
</div>